import { createSelector } from '@ngrx/store';
import { locationsState } from '../root';

export const getLocationsState = createSelector(locationsState, (locations) => locations);
